import React, { useState } from "react";
import { Button, Space, Avatar, Tag, message } from "antd";
import {
  SmileOutlined,
  PaperClipOutlined,
  SendOutlined,
} from "@ant-design/icons";
import useEmails from "hooks/emails/useEmails";
import RichTextEditor from "components/common/RichTextEditor";

export default function ReplyBox({ ticket }) {
  const { sendEmail, loading } = useEmails();
  const [value, setValue] = useState("");

  const handleSend = async () => {
    if (!value.trim()) {
      message.warning("Please enter a message");
      return;
    }

    if (!ticket?.user?.email) {
      message.error("No recipient email found");
      return;
    }

    const cleanedValue = value.replace(
      /<p><br><\/p>/g,
      "<p style='margin:4px 0;'></p>",
    );
    try {
      await sendEmail({
        recipients: [ticket.user.email],
        title: `Re: Support Ticket #${ticket.category}`,
        subject: `Re: Support Ticket #${ticket.category}`,
        body: cleanedValue,
      });

      message.success("Email sent successfully");
      setValue("");
    } catch (err) {
      message.error(err.message || "Failed to send email");
    }
  };

  return (
    <div style={{ marginTop: 24 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: 12,
          fontSize: 13,
          fontFamily: "Inter",
        }}
      >
        <span style={{ color: "#8c8c8c", marginRight: 8 }}>Reply to:</span>
        <Tag
          onClose={() => {}}
          style={{
            borderRadius: 16,
            display: "flex",
            alignItems: "center",
            padding: "2px 8px",
            backgroundColor: "#f5f5f5",
            border: "none",
            fontFamily: "Inter",
          }}
        >
          <Avatar
            size={18}
            src={ticket?.user?.avatar}
            style={{ marginRight: 6 }}
          >
            {ticket?.user?.firstName?.[0]}
          </Avatar>
          {ticket?.user?.firstName} {ticket?.user?.lastName} (
          {ticket?.user?.email})
        </Tag>
      </div>

      <RichTextEditor
        value={value}
        onChange={setValue}
        placeholder="Write a reply..."
        height="180px"
        modules={{
          toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            ["link"],
          ],
        }}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: 10,
        }}
      >
        {/* <Space>
          <Button icon={<PaperClipOutlined />} />
          <Button icon={<SmileOutlined />} />
        </Space> */}

        <Button
          type="primary"
          icon={<SendOutlined />}
          loading={loading}
          onClick={handleSend}
        >
          Send
        </Button>
      </div>
    </div>
  );
}
